export default "__VITE_ASSET__B1S_UKpn__"